export enum RegStatusCode {
     REQUESTED_FOR_MOREINFO = 'RequestedForMoreInfo',
     ACCEPTED = 'Accepted',
     INPROGRESS = 'InProgress',
     SUBMITTED = 'Submitted',
     DENIED = 'Denied',
     REJECTED = 'Rejected',
     INPROCESS = 'InProcess',
     APPROVED = 'Approved',
     STARTED = 'Started'
}